import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';
import AddedValueServiceCMSModel from '@/visa-application/models/AddedValueServiceCMSModel';

export default class OpeningHoursCMSModel implements CMSModel {
  title = '';
  subtitle = '';
  address_title = '';
  opening_hours_title = '';
  closed_days_title = '';
  opening_days_title = '';
  meta_title = '';
  meta_description = '';
  meta_keywords = '';

  map(obj: any): void {
    this.title = _.get(obj, 'translation[0].title', 'Undefined');
    this.subtitle = _.get(obj, 'translation[0].subtitle', 'Undefined');
    this.address_title = _.get(obj, 'translation[0].address_title', 'Undefined');
    this.opening_hours_title = _.get(obj, 'translation[0].opening_hours_title', 'Undefined');
    this.opening_days_title = _.get(obj, 'translation[0].opening_days_title', 'Undefined');
    this.closed_days_title = _.get(obj, 'translation[0].closed_days_title', 'Undefined');
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
  }
}
